import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import "../styles/UsersegmentPie.css";

const COLORS = ["#22c55e", "#f97316"];

const UserSegmentDonutZomato = ({ selectedRestData }) => {





  
  const data = [
    { name: "New Users", value: selectedRestData?.new_users || 0},
    { name: "Repeat Users", value: selectedRestData?.repeat_users || 0 },
  ];

  const total =
  (selectedRestData?.new_users ?? 0) +
  (selectedRestData?.repeat_users ?? 0);
  return (
    <div className="analytics-card">

      <h3 style={{ marginBottom: "10px" }}>User Segmentation</h3>

      <ResponsiveContainer width="100%" height={300}>
        <PieChart>

          <Pie
            data={data}
            innerRadius={70}
            outerRadius={110}
            paddingAngle={4}
            dataKey="value"
            label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
          >
            {data.map((entry, index) => (
              <Cell key={index} fill={COLORS[index]} />
            ))}
          </Pie>

          <Tooltip />
          <Legend wrapperStyle={{ color: "#e2e8f0" }} />

          {/* center value */}
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#ffffff"
            style={{ fontSize: "22px", fontWeight: "600" }}
          >
            {total}
          </text>

        </PieChart>
      </ResponsiveContainer>

    </div>
  );
};

export default UserSegmentDonutZomato;